import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { supabase } from "./supabaseClient";

function normalizeBaseUrl(raw) {
    // allow either:
    //  - http://localhost:5000
    //  - http://localhost:5000/api
    //  - https://your-domain.com
    //  - https://your-domain.com/api
    if (!raw) return "http://localhost:5000/api";

    // trim trailing slash
    let url = raw.replace(/\/+$/, "");

    // ensure it ends with /api
    if (!url.endsWith("/api")) url = `${url}/api`;

    return url;
}

function getBaseUrl() {
    const envUrl = normalizeBaseUrl(import.meta.env.VITE_API_URL || "");

    // Only use the emulator hack when you're truly using localhost.
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android") {
        if (envUrl.startsWith("http://localhost") || envUrl.startsWith("http://127.0.0.1")) {
            return envUrl
                .replace("http://localhost", "http://10.0.2.2")
                .replace("http://127.0.0.1", "http://10.0.2.2");
        }
    }

    return envUrl;
}
const api = axios.create({
    baseURL: getBaseUrl(),
});

// ✅ Pattern A: attach Supabase JWT automatically to every request
api.interceptors.request.use(async (config) => {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;

    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default api;
